import React from 'react';
import ChartPie from '@strapi/icons/ChartPie';
const PluginIcon = () => /*#__PURE__*/React.createElement(ChartPie, null);
export default PluginIcon;